export default function NDARecordDetail({ record }) {
  if (!record) return null;

  const Section = ({ label, children }) => (
    <div className="mb-4">
      <div className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider mb-2">{label}</div>
      {children}
    </div>
  );

  const Field = ({ label, value, mono }) => (
    <div className="flex items-start gap-2 text-sm mb-1.5">
      <span className="text-gray-400 w-32 shrink-0">{label}:</span>
      <span className={`text-vault-navy ${mono ? 'font-mono text-xs' : ''}`}>{value || '—'}</span>
    </div>
  );

  return (
    <div className="space-y-6">
      <Section label="Document">
        <Field label="NDA Version" value={`v${record.nda_version}`} />
        <Field label="Countersign Required" value={record.countersign_required ? 'Yes' : 'No (Acknowledge only)'} />
        {record.document_url && (
          <div className="mt-2">
            <a href={record.document_url} target="_blank" rel="noreferrer"
              className="inline-block px-4 py-2 rounded-btn text-sm font-semibold text-white"
              style={{ background: 'linear-gradient(135deg, #c9a84c, #F59E0B)' }}>
              View NDA Document
            </a>
          </div>
        )}
      </Section>

      <div className="border-t border-vault-border pt-4">
        <Section label="Inventor Signature">
          <Field label="Signed By" value={record.inventor_signature_text} />
          <Field label="User ID" value={record.inventor_user_id} mono />
          <Field label="Signed At" value={record.inventor_signed_at ? new Date(record.inventor_signed_at).toLocaleString('en-US', { dateStyle: 'full', timeStyle: 'long' }) : null} />
          <Field label="IP Address" value={record.inventor_ip_address} mono />
        </Section>
      </div>

      <div className="border-t border-vault-border pt-4">
        <Section label="Company Action">
          <Field label="Action Type" value={record.company_action_type ? (record.company_action_type === 'countersigned' ? 'Countersigned' : 'Acknowledged Receipt') : 'Pending'} />
          <Field label="Signed By" value={record.company_signature_text} />
          <Field label="User ID" value={record.company_user_id} mono />
          <Field label="Action At" value={record.company_action_at ? new Date(record.company_action_at).toLocaleString('en-US', { dateStyle: 'full', timeStyle: 'long' }) : null} />
          <Field label="IP Address" value={record.company_ip_address} mono />
        </Section>
      </div>

      <div className="border-t border-vault-border pt-4">
        <Section label="Metadata">
          <Field label="Record ID" value={record.id} mono />
          <Field label="Connection ID" value={record.connection_id} mono />
          <Field label="Created At" value={record.created_at ? new Date(record.created_at).toLocaleString() : null} />
        </Section>
      </div>

      {/* E-SIGN compliance note */}
      <div className="bg-gray-50 rounded-btn p-4">
        <p className="text-[11px] text-gray-400 leading-relaxed">
          This record was created under the Electronic Signatures in Global and National Commerce Act (E-SIGN Act).
          NDA records are immutable — they cannot be edited or deleted by any user, including administrators.
        </p>
      </div>
    </div>
  );
}
